import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  {
    id: 'welcome',
    title: 'Welcome to IntegratePulse',
    body: 'You\'re about to monitor every API, system, and integration in your stack — 24/7, automatically. This quick tour shows you how. Takes 2 minutes.',
    position: 'center',
    target: null,
  },
  {
    id: 'dashboard',
    title: 'Your command center',
    body: 'The dashboard shows the real-time health of all your integrations — uptime %, response times, active alerts, and a 24-hour history chart. It refreshes every 30 seconds automatically.',
    position: 'center',
    target: null,
  },
  {
    id: 'add',
    title: 'Add your first integration',
    body: 'Click "+ Add integration" to connect any API, database, ERP system, or AI endpoint. Paste a URL, set authentication if needed, and you\'re monitoring in under 60 seconds.',
    position: 'center',
    target: null,
  },
  {
    id: 'alerts',
    title: 'Get notified instantly',
    body: 'When something breaks or slows down, IntegratePulse fires an alert to your email and Slack — before your customers notice. Configure your alert channels in Alert Settings.',
    position: 'center',
    target: null,
  },
  {
    id: 'status',
    title: 'Your public status page',
    body: 'Share your status page URL with customers so they always know your system health. It updates in real-time and requires zero maintenance from you.',
    position: 'center',
    target: null,
  },
  {
    id: 'done',
    title: 'You\'re ready to go',
    body: 'Add your first integration and watch the dashboard come alive. If anything goes down, you\'ll know within 60 seconds. Welcome to always-on monitoring.',
    position: 'center',
    target: null,
  },
];

export default function OnboardingTour({ onComplete }) {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  function next() {
    if (isLast) {
      onComplete();
    } else {
      setStep(s => s + 1);
    }
  }

  function skip() {
    onComplete();
  }

  function handleAction() {
    if (step === 2) {
      onComplete();
      navigate('/integrations/add');
      return;
    }
    next();
  }

  return (
    <>
      <div className="tour-overlay" onClick={skip} />
      <div
        className="tour-card"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="tour-step-num">Step {step + 1} of {STEPS.length}</div>
        <div className="tour-title">{current.title}</div>
        <div className="tour-body">{current.body}</div>

        <div className="tour-progress">
          {STEPS.map((_, i) => (
            <div key={i} className={`tour-pip ${i <= step ? 'done' : ''}`} />
          ))}
        </div>

        <div className="tour-actions">
          <button className="tour-skip" onClick={skip}>
            {isLast ? '' : 'Skip tour'}
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            {step > 0 && (
              <button
                className="btn-secondary"
                style={{ padding: '8px 14px', fontSize: 13 }}
                onClick={() => setStep(s => s - 1)}
              >
                Back
              </button>
            )}
            <button className="btn-primary" onClick={handleAction}>
              {isLast ? 'Get started' : step === 2 ? 'Add integration ↗' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export function TourButton({ onStart }) {
  return (
    <button
      className="btn-ghost"
      onClick={onStart}
      style={{ fontSize: 12 }}
      title="Take the guided tour"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M7 6.5v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        <circle cx="7" cy="4.5" r="0.7" fill="currentColor"/>
      </svg>
      Tour
    </button>
  );
}
